import React from "react";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faGraduationCap}
				title="Education"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="./graduate.png"
								alt="PG"
								className="work-image"
							/>
							<div className="work-title">M.Sc Physics (scored 72%)</div>
							
							<div className="work-subtitle">
								Dept. of Physics, M.S University 
							</div>
							
							<div className="work-duration">1996 - 1998</div>
						</div>

						<div className="work">
							<img
								src="./graduate.png"
								alt="UG"
								className="work-image"
							/>
							<div className="work-title">B.Sc Physics (scored 83%)</div>
							<div className="work-subtitle">
								M.D.T Hindu College 
							</div>
							<div className="work-duration">1993- 1996</div>
						</div>
						<div className="work">
							<img
								src="./graduate.png"
								alt="HSLC"
								className="work-image"
							/>
							<div className="work-title">12th (scored 82%)</div>
							<div className="work-subtitle">
								M.D.T Hindu College & Hr. Sec School
							</div>
							<div className="work-duration">1991 - 1993</div>
						</div>
						<div className="work">
							<img
								src="./graduate.png"
								alt="SSLC"
								className="work-image"
							/>
							<div className="work-title">10th (scored 85%)</div>
							<div className="work-subtitle">
								Schaffter Hr. Sec School
							</div>
							<div className="work-duration">1991</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
